import { cn } from "@/lib/utils";

const categories = [
  {
    title: "Ball Bearings",
    description: "Versatile bearings with rolling elements that reduce friction in rotary applications. Perfect for high-speed operations with moderate loads.",
    image: "/images/cats/ball_bearing.png",
    alt: "High-quality ball bearings for rotary applications - Avon Bearings"
  },
  {
    title: "Taper Bearings",
    description: "Designed to handle combined radial and thrust loads. Ideal for automotive wheel hubs and industrial gearboxes.",
    image: "/images/cats/taper_bearing.png",
    alt: "Precision taper roller bearings for automotive and industrial use - Avon Bearings"
  },
  {
    title: "Spherical Bearings",
    description: "Self-aligning bearings that accommodate shaft misalignment. Excellent for heavy industrial machinery and equipment.",
    image: "/images/cats/spherical_bearing.png",
    alt: "Self-aligning spherical bearings for heavy industrial machinery - Avon Bearings"
  },
  {
    title: "Cylindrical Bearings",
    description: "High load capacity bearings optimized for pure radial loads. Common in heavy machinery and rolling mills.",
    image: "/images/cats/cylindrical_bearing.png",
    alt: "Cylindrical roller bearings for heavy radial load applications - Avon Bearings"
  },
  {
    title: "Thrust Bearings",
    description: "Specifically designed to handle axial loads in one direction. Essential for vertical shaft applications.",
    image: "/images/cats/thrust_bearing.png",
    alt: "Thrust bearings for axial load and vertical shaft applications - Avon Bearings"
  },
  {
    title: "Needle Roller Bearings",
    description: "Compact bearings with high load capacity using long, thin rollers. Perfect for limited radial space applications.",
    image: "/images/cats/needle_bearing.png",
    alt: "Compact needle roller bearings for space-constrained applications - Avon Bearings"
  },
  {
    title: "Oil Seals",
    description: "Prevent lubricant leakage and protect against contaminants. Available in various materials for different environments.",
    image: "/images/cats/oil_seal.png",
    alt: "Industrial oil seals for bearing protection and lubricant retention - Avon Bearings"
  },
  {
    title: "Industrial Greases",
    description: "High-quality lubricants for all bearing types. Including specialized high-temperature grease formulations.",
    image: "/images/cats/industrial_grease.png",
    alt: "Industrial greases and lubricants for bearing maintenance - Avon Bearings"
  },
  {
    title: "Pillow Blocks",
    description: "Ready-to-mount bearing units with housings. Simplify installation and maintenance in various applications.",
    image: "/images/cats/pillow_block.png",
    alt: "Pillow block bearing units for easy mounting and maintenance - Avon Bearings"
  },
  {
    title: "LM Guides",
    description: "Linear motion guides providing smooth, precise movement. Ideal for automation and precision machinery.",
    image: "/images/cats/lm_guide.png",
    alt: "Linear motion LM guides for automation and precision machinery - Avon Bearings"
  },
  {
    title: "Linear Motion Bearings",
    description: "Enable smooth linear movement along shafts. Essential for automated systems and precision equipment.",
    image: "/images/cats/linear_bearing.png",
    alt: "Linear motion bearings for automated systems and CNC machines - Avon Bearings"
  },
];

export function CategoriesSection() {
  return (
    <section id="categories" className="py-16 md:py-24 bg-muted/50">
      <div className="container">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">Categories We Deal In</h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            Explore our comprehensive range of high-quality bearings designed for reliability and performance
          </p>
        </div>

        <div className="relative">
          <div className="overflow-x-auto pb-4 [&::-webkit-scrollbar]:h-1.5 [&::-webkit-scrollbar-thumb]:bg-gray-300/50 [&::-webkit-scrollbar-track]:bg-transparent hover:[&::-webkit-scrollbar-thumb]:bg-gray-300/70 dark:[&::-webkit-scrollbar-thumb]:bg-gray-400/30 dark:hover:[&::-webkit-scrollbar-thumb]:bg-gray-400/50">
            <div className="flex gap-6 min-w-max px-4">
              {categories.map((category, index) => (
                <div key={index} className="w-[300px] flex-shrink-0">
                  <div className="group relative overflow-hidden rounded-lg border bg-background transition-all hover:shadow-lg hover:border-primary/20">
                    <div className="aspect-square w-full overflow-hidden bg-gray-50/50">
                      <img
                        src={category.image}
                        alt={category.alt}
                        className="h-full w-full object-contain p-4 transition-transform duration-300 group-hover:scale-105"
                        loading="lazy"
                      />
                    </div>
                    <div className="p-6">
                      <h3 className="font-semibold text-lg mb-2 line-clamp-1">{category.title}</h3>
                      <p className="text-sm text-muted-foreground line-clamp-3">{category.description}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
